import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../../../config/farmDetails";
import { harvestYearDetail } from "../../../../../config/harvestYearDetail";
import { commListAction, createCommVarietyAction } from "../../../../../modules/commvarieties/action";
import "../../../../../style";
import { validForm } from "../../../../FormElement/FormValidator";
import CommVarietyForm from "./CommVarietyForm";


class CreateCommVariety extends Component {
  constructor(props) {
    super(props);

    this.state = {
      commVarietyInfo: {
        farmId: userFarmDetail().id || props.MainFarmId,
        commodityType: "",
        variety: "",
        harvestYear: harvestYearDetail().name
      },
      formErrors: {
        commodityType: "",
        variety: ""
      },
      isValid: true,
      successMessage: "",
      errorMessage: {},
      edited: false
    };
  }

  componentDidUpdate = () => {
    if (this.state.edited) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  componentWillUnmount() {
    window.onbeforeunload = undefined;
  }

  componentDidMount() {
    const { commListAction } = this.props;
    commListAction();
  }

  handleChange = event => {
    if (!this.state.edited) this.setState({ edited: true });
    const { name, value } = event.target;
    if (name === "variety") {
      if (value.match(/^(\w|\ ){0,51}$/)) {
        this.updateState(name, value);
      }
    } else {
      this.updateState(name, value);
    }
  };

  updateState = (name, value) => {
    this.setState(
      prevState => {
        return {
          commVarietyInfo: {
            ...prevState.commVarietyInfo,
            [name]: value
          }
        };
      },
      () => {
        const { commVarietyInfo } = this.state;
        this.setState({
          isValid: validForm(this.state.formErrors, commVarietyInfo)
        });
      }
    );
  };

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { commVarietyInfo } = this.state;
        this.setState({
          isValid: validForm(this.state.formErrors, commVarietyInfo)
        });
      }
    );
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.varietyCreated && nextProps.varietyCreated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  createCommVariety = e => {
    e.preventDefault();
    const { commVarietyInfo, isValid } = this.state;
    commVarietyInfo.farmId = userFarmDetail().id || this.props.MainFarmId;
    commVarietyInfo.harvestYear = harvestYearDetail().name;
    this.setState({ isValid: true, edited: false });
    this.props.createCommVarietyAction(commVarietyInfo);
  };

  render() {
    const { successMessage, commVarietyInfo, isValid, edited } = this.state;
    const { commVar } = this.props;
    if (successMessage) {
      return <Redirect to="/farmsetup/farminformation/commodity-varieties" />;
    }
    return (
      <CommVarietyForm
        buttonLabel="Add new variety"
        formLabel="Set up your Commodity Variety"
        commVarietyInfo={commVarietyInfo}
        handleChange={this.handleChange}
        handleError={this.handleError}
        createCommVariety={this.createCommVariety}
        isValid={isValid}
        commVar={commVar}
        edited={edited}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    commVar: state.commVarReducer.commListVar,
    varietyCreated: state.commVarReducer.varietyCreated,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ createCommVarietyAction, commListAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateCommVariety);



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/CommodityVarietes/CreateCommVariety.js